import { useCartStore } from '../../store/cartStore';
import { QuoteLine } from '../../types/commerce';
import ProductPrice from '../ProductPrice/ProductPrice';
import QuantityStepper from '../QuantityStepper/QuantityStepper';

interface Props {
  /** Quoted lines, when a quote exists, supply display names and live prices. */
  readonly quotedLines: readonly QuoteLine[] | undefined;
  /** The cart cannot change while a payment is in progress. */
  readonly locked: boolean;
}

export default function CheckoutItems({ quotedLines, locked }: Props) {
  const items = useCartStore((s) => s.items);
  const increment = useCartStore((s) => s.increment);
  const decrement = useCartStore((s) => s.decrement);
  const removeItem = useCartStore((s) => s.removeItem);
  const syncError = useCartStore((s) => s.syncError);
  return (
    <section>
      <h2>Your products</h2>
      {syncError && <p role="alert">{syncError}</p>}
      {items.map((item) => {
        const line = quotedLines?.find((quoted) => quoted.item_id === item.inventory_id);
        return (
          <article className="checkout-product" key={item.inventory_id}>
            <img src={item.image_url} alt="" />
            <div>
              <p>{line?.display_name ?? item.description}</p>
              {line ? <ProductPrice pricing={line.pricing} /> : <p>Price calculated in order summary</p>}
              {item.available_quantity === 0 ? (
                <p className="checkout-product__stock">Sold out. Remove it to check out.</p>
              ) : item.available_quantity !== undefined && item.quantity > item.available_quantity ? (
                <p className="checkout-product__stock">Only {item.available_quantity} left.</p>
              ) : null}
              <QuantityStepper
                quantity={item.quantity}
                onIncrement={() => {
                  if (!locked) increment(item.inventory_id);
                }}
                onDecrement={() => {
                  if (!locked) decrement(item.inventory_id);
                }}
              />
              <button disabled={locked} onClick={() => removeItem(item.inventory_id)}>
                Remove
              </button>
            </div>
          </article>
        );
      })}
    </section>
  );
}
